import '../styles/main.css';
import trilhoLoginImg           from '../assets/LoginPage/trilho-login.png';
import logoFipsImg              from '../assets/LoginPage/logo-fips-hotizontal.png';
import backgroundLoginFormImg   from '../assets/LoginPage/background-login-form.png';
import logoMobile               from '../assets/NavBar/logo-sidebar.svg';
import LoginFormContainer       from '../components/Form/LoginFormContainer.js';

function LoginPage() {
  
    return (

        <div className="w-full flex flex-row bg-azul-profundo-e max-h-screen xl:p-0 p-0 xl:m-0 m-0 xl:overflow-hidden overflow-hidden h-screen pt-[20%]">

            {/* Seção de Imagens */}

            <section className="min-h-full w-1/2 ">
            
                <div>
                    <img className="xl:h-full xl:absolute xl:flex hidden" src={trilhoLoginImg} alt="Imagem do trilho de login" draggable="false" />
                </div>

                <div className='w-screen p-[15px] mt-[10px] h-[70px] justify-center flex items-center xl:left-[1px] xl:flex xl:justify-start hidden'>
                    <img className="m-[15px] h-[55px] xl:h-8 xl:flex hidden" src={logoFipsImg} alt="Logo da FIPS" />
                </div>

                <div className='xl:hidden w-screen pt-[60px] flex border-red items-center justify-center' >
                    <img className="xl:hidden flex w-[80px] " src={logoMobile} alt="Logo da FIPS" draggable="false" />
                </div>

            </section>

            {/* Seção do Formulário */}
            <section className="h-full w-1/2 items-center justify-center">
            
                <div className="xl:m-[47%] xl:h-[500px] xl:w-[500px] xl:transform xl:translate-x-[-50%] xl:translate-y-[-50%] flex w-[350px] h-[full]">
                
                    <div className='h-[full] xl:flex xl:justify-start items-center justify-center'>
                        <img className="h-[480px] xl:flex hidden absolute " src={backgroundLoginFormImg} alt="Imagem de fundo do formulário de login" />
                    </div>
                
                    <div className=" xl:absolute m-[50%] xl:-translate-x-1/2 xl:-translate-y-[60%] xl:flex xl:flex-col xl:gap-4 fixed translate-x-[-100%] w-[100%]">
                
                        <LoginFormContainer/>

                    </div>
                
                </div>

            </section>

        </div>
  );
}

export default LoginPage;